'use client';

export { default } from './SpeedDialAction';
export { default as speedDialActionClasses } from './speedDialActionClasses';
export * from './speedDialActionClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/SpeedDialAction/index.js
// module id = 955
// module chunks = 25